import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { HOST_URL } from "../../../../../Config";
import { StoreContext } from "../../../../../Store/Provider";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import "./ContainerDetails.css";
import { CircularProgress } from "@material-ui/core";
import { map } from "jquery";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "../../../../../Route/utils/routeConstant";

function Container(props) {
  const context = useContext(StoreContext);
  const [locationdata, setLocationdata] = useState([]);
  const [containerData, setContainerData] = useState([]);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    getLocation();
  }, []);

  const getmodifiedData = (newdata) => {
    const tempLocArr = [];
    const locationMilestone = [];
    newdata.containers.map((i) => {
      const arr = i.events;
      arr.map((i) => {
        tempLocArr.push(i.location);
      });
      newdata.locations.map((item, index, newLocation) => {
        const location = [];
        arr.map((k) => {
          if (item.id === k.location) {
            location.push(k);
          }
        });
        const obj = { ...item, milestone: location };
        locationMilestone.push({ ...obj });
      });
    });

    const set = new Set(tempLocArr);
    const sortedArray = [];
    [...set].map((i) => {
      sortedArray.push(locationMilestone[i - 1]);
    });
    setContainerData([...newdata.containers]);
    setLocationdata([...sortedArray]);
  };

  const getLocation = () => {
    setLoading(true);
    const url = `${HOST_URL}api/v1/Location/getLocationBasedOnMbl?mblNumber=${context.shipmentdetails.MasterBillNumber}&sealine=${context.shipmentdetails.CarrierCode}&type=BL`;
    axios
      .post(url)
      .then((res) => {
        console.log(res);
        if (res.data.status === "error") {
          NotificationManager.error(res.data.message, "", 3000);
        }

        getmodifiedData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  console.log(locationdata);

  return (
    <div className="_orderListFullDetailsMilestone">
      <h5>
        <span onClick={() => history(routeConstant.ShipmentsListing)}>
          <ArrowBackIosIcon />
        </span>
        {context.shipmentdetails.ShipmentId}
      </h5>
      <div className="_orderFullDetailsLineTabDiv">
        {loading ? (
          <div className="loadingClass" style={{ height: "100%" }}>
            <CircularProgress />
          </div>
        ) : containerData ? (
          <TabContext value={value}>
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              {containerData?.map((value, index) => {
                return <Tab label={value.number} />;
              })}
            </TabList>
            <SwipeableViews
              index={value}
              onChangeIndex={(index) => setValue(index)}
            >
              {locationdata?.map((ele, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={value}
                    key={index}
                    className="_orderFullDetailsLineDataTabDiv _orderListFullDetailsComponentTableDiv "
                  >
                    <div className="_orderListMilestone">
                      <div className="_orderTimelineDivParent">
                        {locationdata.length != 0 ? (
                          locationdata.map((item, index, arr) => {
                            const length = arr.length - 1;
                            return (
                              <>
                                <div className="_orderTimelineDiv">
                                  <div className="_orderTimelineDotLine">
                                    <div className="_orderTimelineDot "></div>
                                    {length != index ? (
                                      <>
                                        <div className="_orderTimelineLine"></div>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className="_orderTimelineInputs ">
                                    <>
                                      <h6>
                                        {item.name}( {item.country})
                                      </h6>
                                      <table className="card">
                                        <tbody>
                                          {item.milestone.map((i) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {moment(i.date).format(
                                                    "MM-DD-YYYY"
                                                  )}
                                                </td>
                                                <td>:</td>
                                                <td>{i.description}</td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </>
                                  </div>
                                </div>
                                {locationdata.length - 1 !== index ? (
                                  <div className="_orderTimelineDiv">
                                    <div className="_orderTimelineDotLine">
                                      <div className="_orderTimelineDot numDays "></div>
                                      {length != index ? (
                                        <>
                                          <div className="_orderTimelineLine"></div>
                                        </>
                                      ) : null}
                                    </div>
                                    <div
                                      className="_orderTimelineInputs "
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <>
                                        <table className="card">
                                          <tbody>
                                            <h6>
                                              {locationdata[index].name}
                                              {"-"}
                                              {locationdata[index + 1].name}
                                            </h6>
                                            <tr className="trDateDiff">
                                              <td>
                                                {moment(
                                                  locationdata[index].milestone[
                                                    locationdata[index]
                                                      .milestone.length - 1
                                                  ].date
                                                ).format("MM-DD-YYYY")}{" "}
                                                {"-"}{" "}
                                                {moment(
                                                  locationdata[index + 1]
                                                    .milestone[0].date
                                                ).format("MM-DD-YYYY")}
                                              </td>
                                              <td>
                                                {" "}
                                                {(new Date(
                                                  moment(
                                                    locationdata[index + 1]
                                                      .milestone[0].date
                                                  ).format("MM-DD-YYYY")
                                                ).getTime() -
                                                  new Date(
                                                    moment(
                                                      locationdata[index]
                                                        .milestone[
                                                        locationdata[index]
                                                          .milestone.length - 1
                                                      ].date
                                                    ).format("MM-DD-YYYY")
                                                  ).getTime()) /
                                                  (1000 * 3600 * 24)}{" "}
                                                days
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </>
                                    </div>
                                  </div>
                                ) : null}
                              </>
                            );
                          })
                        ) : (
                          <div
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              display: "flex",
                            }}
                          >
                            Milestone not found
                          </div>
                        )}
                      </div>
                    </div>
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          </TabContext>
        ) : (
          <div className="loadingClass" style={{ height: "100%" }}>
            <p className="nosidebarDataPara">No milestone available!</p>{" "}
          </div>
        )}
      </div>
    </div>
  );
}

export default Container;
